import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Box, CircularProgress } from '@mui/material';

const AddDebtModal = ({ isOpen, onClose, onSave, customerName }) => {
  const [amount, setAmount] = useState('');
  const [description, setDescription] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  const handleSubmit = async () => {
    if (!amount || parseFloat(amount) <= 0) {
      alert('Lütfen geçerli bir tutar giriniz.');
      return;
    }
    setIsSaving(true);
    try {
      await onSave({
        amount: parseFloat(amount),
        description: description
      });
      onClose();
      setAmount('');
      setDescription('');
    } catch (error) {
      console.error("Borç eklenirken hata: ", error);
      alert("Bir hata oluştu.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Borç Ekle: {customerName}</DialogTitle>
      <DialogContent>
        <Box component="form" noValidate sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField label="Tutar (₺)" type="number" value={amount} onChange={(e) => setAmount(e.target.value)} required autoFocus />
          <TextField label="Açıklama" value={description} onChange={(e) => setDescription(e.target.value)} multiline rows={2} />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: '16px 24px' }}>
        <Button onClick={onClose} disabled={isSaving}>İptal</Button>
        <Button onClick={handleSubmit} variant="contained" disabled={isSaving}>
          {isSaving ? <CircularProgress size={24} /> : 'Borcu Kaydet'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddDebtModal;
